import { render, staticRenderFns } from "./newsForm.vue?vue&type=template&id=1ee884d2&scoped=true"
import script from "./newsForm.vue?vue&type=script&lang=js"
export * from "./newsForm.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./newsForm.vue?vue&type=style&index=1&id=1ee884d2&prod&lang=scss&scoped=true"
import style2 from "./newsForm.vue?vue&type=style&index=2&id=1ee884d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee884d2",
  null
  
)

export default component.exports